// #428: click-only nav (RS Online pattern) for all .has-sub-menu items in
// the desktop header main nav. Pairs with the CSS change that swapped
// :hover for .is-open on .navigation-menu submenu visibility rules.
//
// Behaviour:
// - Click on a nav item with submenu → toggle .is-open on the <li>.
//   Closes other sibling .has-sub-menu at the same level.
// - Click on the link's href is suppressed (preventDefault) for items
//   with submenus — user clicks a child link to navigate, OR clicks the
//   "Shop all X" link inside the dropdown if present. Items without
//   submenus are not bound — their links navigate normally.
// - Click outside the open menu → close all open levels.
// - Press Escape → close all open levels + return focus to the most-
//   recently-opened trigger (or document.activeElement fallback).
// - aria-expanded is synced on the trigger link.
//
// Out of scope: vertical-tabs-menu (handled separately by the
// VerticalTabsMenu custom element in scripts.js).
// Out of scope: mobile drawer menu (uses its own toggle).

document.addEventListener("DOMContentLoaded", () => {
  // Only desktop header main nav. Mobile uses a separate drawer.
  const mainNavs = document.querySelectorAll("header .navigation-main");
  if (mainNavs.length === 0) return;

  const hasSubMenuItems = [];
  mainNavs.forEach((nav) => {
    nav.querySelectorAll(".has-sub-menu").forEach((item) => hasSubMenuItems.push(item));
  });
  if (hasSubMenuItems.length === 0) return;

  function closeItem(item) {
    item.classList.remove("is-open");
    const link = item.querySelector(":scope > a");
    if (link) link.setAttribute("aria-expanded", "false");
    // Also close any nested open submenus inside this one.
    item.querySelectorAll(".has-sub-menu.is-open").forEach((nested) => {
      nested.classList.remove("is-open");
      const nestedLink = nested.querySelector(":scope > a");
      if (nestedLink) nestedLink.setAttribute("aria-expanded", "false");
    });
  }

  function closeSiblings(item) {
    const parent = item.parentElement;
    if (!parent) return;
    parent.querySelectorAll(":scope > .has-sub-menu.is-open").forEach((sib) => {
      if (sib !== item) closeItem(sib);
    });
  }

  hasSubMenuItems.forEach((item) => {
    const link = item.querySelector(":scope > a");
    if (!link) return;

    // Initialise aria-expanded for screen readers.
    link.setAttribute("aria-expanded", "false");
    link.setAttribute("aria-haspopup", "true");

    link.addEventListener("click", (e) => {
      e.preventDefault();
      e.stopPropagation();
      const isOpen = item.classList.contains("is-open");
      closeSiblings(item);
      if (isOpen) {
        closeItem(item);
      } else {
        item.classList.add("is-open");
        link.setAttribute("aria-expanded", "true");
      }
    });
  });

  // Outside-click closes all open menus in this nav.
  document.addEventListener("click", (e) => {
    mainNavs.forEach((nav) => {
      const openItems = nav.querySelectorAll(".has-sub-menu.is-open");
      openItems.forEach((item) => {
        if (!item.contains(e.target)) closeItem(item);
      });
    });
  });

  // Escape closes everything + returns focus to the deepest open trigger.
  document.addEventListener("keydown", (e) => {
    if (e.key !== "Escape") return;
    let lastFocused = null;
    mainNavs.forEach((nav) => {
      nav.querySelectorAll(".has-sub-menu.is-open").forEach((item) => {
        const link = item.querySelector(":scope > a");
        if (link) lastFocused = link;
        closeItem(item);
      });
    });
    if (lastFocused) lastFocused.focus();
  });
});
